import { render, staticRenderFns } from "./FlowHeader.vue?vue&type=template&id=af0656f8&"
import script from "./FlowHeader.vue?vue&type=script&lang=js&"
export * from "./FlowHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports